import { gql } from "@apollo/client";

export const UPDATE_MACHINE = gql`
	mutation UpdateMachine($input: JSON) {
		updateMachine(input: $input)
	}
`;
